import React from "react";
import { Button, Form, Tab, Nav } from "react-bootstrap";
import './budgetreconciliationtab.css';

const Budgetreconciliationtab: React.FC = () => {
    return (
        <>
            <div className="common_card mby_20">
                <div className="top top_bar_flx border_tittle mby_16">
                    <div className="top_bar_tittle">
                        <h2 className="mb-2">Pre‑Submission Scrubber</h2>
                        <p>Run automated checks before creating a CMS‑1500/837P batch for September 2025. This triggers monthly 270/271 eligibility checks for the batch window.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="NPI & Taxonomy ✓" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="T‑code & Modifiers ✓" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="ICD‑10 present ✓" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="POS valid ✓" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="Eligibility (270/271) ✓" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="Units within cap ✓" />
                        </Form.Group>
                    </div>
                </div>
                <div className="form_btn_flx justify-content-start">
                    <Button variant="primary" className="btn_sm">Run Scrubber</Button>
                    <Button variant="light" className="btn_sm">View Errors (5)</Button>
                </div>
            </div>
            <div className="common_card mby_20">
                <div className="top top_bar_flx border_tittle mby_16">
                    <div className="top_bar_tittle">
                        <h2>Billability Reconciliation — Waivera vs. PA Release (LaSRS) vs. Paid</h2>
                    </div>
                    <div className="top_right_flx">
                        <Button variant="light" className="btn_sm">Export Variance CSV</Button>
                        <Button variant="primary" className="btn_sm">Generate All Packets</Button>
                    </div>
                </div>
                <div className="gemittances_card_grid mby_20">
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Waivera Billable</p>
                            <h3>212 claims</h3>
                            <p className="mb-0 mt-2">$48,120</p>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>PA Released (LaSRS)</p>
                            <h3>196 claims</h3>
                            <p className="mb-0 mt-2">$44,580</p>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Paid</p>
                            <h3>188 claims</h3>
                            <p className="mb-0 mt-2">$42,720</p>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Variance</p>
                            <h3 style={{ color: '#D32F2F' }}>-24 claims</h3>
                            <p className="mb-0 mt-2" style={{ color: '#D32F2F' }}>-$5,350 not realized</p>
                        </div>
                    </div>

                    {/* Add Table Here */}

                </div>
            </div>
            <div className="common_card mby_20">
                <div className="top top_bar_flx border_tittle mby_16">
                    <div className="top_bar_tittle">
                        <h2 className="mb-2">Evidence Packet Builder</h2>
                        <p>Create a PDF/ZIP with cover sheet, rule checklist, logs, timestamps,  e‑signed docs, and system IDs to forward to the appropriate agency.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="Cover Sheet (member, DOS, units, code)" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="Rule Checklist (Min Contacts, Plan Update, Encounter, Caps, Auth)" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="Contact Logs & Notes (timestamps)" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="E‑signed Plan & Docs" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="LaSRS visit audit / SIMS task IDs" />
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="Templated Appeal Letter" />
                        </Form.Group>
                    </div>
                </div>
                <div className="form_btn_flx justify-content-start">
                    <Button variant="primary" className="btn_sm">Generate Packet</Button>
                    <Button variant="light" className="btn_sm">Customize Template</Button>
                </div>
            </div>
            <div className="common_card">
                <div className="top top_bar_flx border_tittle mby_16">
                    <div className="top_bar_tittle">
                        <h2 className="mb-2">Packet Templates by Waiver Type</h2>
                        <p>Default evidence packet template used on Generate Packet. Reps can override per claim.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <Form.Group className="custom_input_flled waiver_type_filled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="OCDD" />
                            <Form.Select aria-label="Default select example" className="sm_input filled_white">
                                <option>Standard</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <Form.Group className="custom_input_flled waiver_type_filled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="OAAS" />
                            <Form.Select aria-label="Default select example" className="sm_input filled_white">
                                <option>Standard</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <Form.Group className="custom_input_flled waiver_type_filled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="EPSDT" />
                            <Form.Select aria-label="Default select example" className="sm_input filled_white">
                                <option>Peds</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <Form.Group className="custom_input_flled waiver_type_filled" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="ROW" />
                            <Form.Select aria-label="Default select example" className="sm_input filled_white">
                                <option>Standard</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                </div>
                <div className="form_btn_flx justify-content-start">
                    <Button variant="primary" className="btn_sm">Save Defaults</Button>
                    <Button variant="light" className="btn_sm">Customize Template</Button>
                </div>
            </div>
        </>
    );
};

export default Budgetreconciliationtab;
